import { concatL, filterL, go, mapL, rejectL } from "fxjs/es";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { PROCESSING_TASK } from "./const.js";
export const _handleTouchStartOnCanvasEl = (self, event) => {
  const selector_e_circle_el = self._getSelectorECircleElThrowable();
  const selector_s_circle_el = self._getSelectorSCircleElThrowable();
  const selection = self._getSelectionThrowable();
  const selection_scale_transform2 =
    self._getSelectionScaleTransform2Throwable();
  event.preventDefault();
  const {
    changedTouches: changed_touches,
    targetTouches: target_touches,
    touches,
  } = event;
  const target_touch_id_set = go(
    CommonNS.UtilNS.convertTouchListToGen(target_touches),
    mapL(({ identifier }) => identifier),
    (iter) => new Set(iter)
  );
  const target_changed_touch_map = go(
    CommonNS.UtilNS.convertTouchListToGen(changed_touches),
    filterL(({ identifier }) => target_touch_id_set.has(identifier)),
    mapL((touch) => [touch.identifier, [touch, touch]]),
    (entries) => new Map(entries)
  );
  const touch_id_set = go(
    CommonNS.UtilNS.convertTouchListToGen(touches),
    mapL(({ identifier: id }) => id),
    (iter) => new Set(iter)
  );
  self._touch_map = go(
    target_changed_touch_map.entries(),
    concatL(self._touch_map.entries()),
    rejectL(([id]) => !touch_id_set.has(id)),
    (entries) => new Map(entries)
  );
  const selected_el_set = selection.getSelectedEls();
  switch (self._processing_task) {
    case PROCESSING_TASK.PATH_EDITING: {
      if (self._touch_map.size < 2) {
        return;
      }
      const touch_iter = self._touch_map.values();
      const touch1 = touch_iter.next().value?.[1];
      if (touch1 == null) {
        return;
      }
      const {
        identifier: touch_id1,
        clientX: client_x1,
        clientY: client_y1,
      } = touch1;
      const point1 = self._toViewPortPoint({
        x: client_x1,
        y: client_y1,
      });
      const touch2 = touch_iter.next().value?.[1];
      if (touch2 == null) {
        return;
      }
      const {
        identifier: touch_id2,
        clientX: client_x2,
        clientY: client_y2,
      } = touch2;
      const point2 = self._toViewPortPoint({
        x: client_x2,
        y: client_y2,
      });
      self._processing_task = PROCESSING_TASK.PATH_EDITING_ZOOMING_AND_PANNING;
      self._zooming_and_panning_touch_id1 = touch_id1;
      self._zooming_and_panning_progress_touch_x1 = point1.x;
      self._zooming_and_panning_progress_touch_y1 = point1.y;
      self._zooming_and_panning_touch_id2 = touch_id2;
      self._zooming_and_panning_progress_touch_x2 = point2.x;
      self._zooming_and_panning_progress_touch_y2 = point2.y;
      return;
    }
    case null: {
      if (self._touch_map.size >= 2 && selected_el_set.size > 0) {
        const touch_iter = self._touch_map.values();
        const touch1 = touch_iter.next().value?.[1];
        if (touch1 == null) {
          return;
        }
        const {
          identifier: touch_id1,
          clientX: client_x1,
          clientY: client_y1,
        } = touch1;
        const point1 = self._toViewPortPoint({
          x: client_x1,
          y: client_y1,
        });
        const touch2 = touch_iter.next().value?.[1];
        if (touch2 == null) {
          return;
        }
        const {
          identifier: touch_id2,
          clientX: client_x2,
          clientY: client_y2,
        } = touch2;
        const point2 = self._toViewPortPoint({
          x: client_x2,
          y: client_y2,
        });
        const origin_point = self._getSelectorCenterPointInViewPort();
        if (origin_point == null) {
          return;
        }
        const { x: origin_x, y: origin_y } = origin_point;
        const x_axis_point = CommonNS.UtilNS.getCenterPointInViewPort(
          self._svg_el
        )(selector_e_circle_el);
        if (x_axis_point == null) {
          return;
        }
        const { x: x_axis_x, y: x_axis_y } = x_axis_point;
        const y_axis_point = CommonNS.UtilNS.getCenterPointInViewPort(
          self._svg_el
        )(selector_s_circle_el);
        if (y_axis_point == null) {
          return;
        }
        const { x: y_axis_x, y: y_axis_y } = y_axis_point;
        selection_scale_transform2.start({
          x1: point1.x,
          y1: point1.y,
          x2: point2.x,
          y2: point2.y,
          origin_x,
          origin_y,
          x_axis_x,
          x_axis_y,
          y_axis_x,
          y_axis_y,
          els: [...selection.getSelectedEls()],
        });
        self._processing_task = PROCESSING_TASK.SCALE_TRANSFORMING2;
        self._scale_transforming2_touch_id1 = touch_id1;
        self._scale_transforming2_touch_id2 = touch_id2;
        return;
      }
      if (self._touch_map.size >= 2) {
        const touch_iter = self._touch_map.values();
        const touch1 = touch_iter.next().value?.[1];
        if (touch1 == null) {
          return;
        }
        const {
          identifier: touch_id1,
          clientX: client_x1,
          clientY: client_y1,
        } = touch1;
        const point1 = self._toViewPortPoint({
          x: client_x1,
          y: client_y1,
        });
        const touch2 = touch_iter.next().value?.[1];
        if (touch2 == null) {
          return;
        }
        const {
          identifier: touch_id2,
          clientX: client_x2,
          clientY: client_y2,
        } = touch2;
        const point2 = self._toViewPortPoint({
          x: client_x2,
          y: client_y2,
        });
        self._processing_task = PROCESSING_TASK.ZOOMING_AND_PANNING;
        self._zooming_and_panning_touch_id1 = touch_id1;
        self._zooming_and_panning_progress_touch_x1 = point1.x;
        self._zooming_and_panning_progress_touch_y1 = point1.y;
        self._zooming_and_panning_touch_id2 = touch_id2;
        self._zooming_and_panning_progress_touch_x2 = point2.x;
        self._zooming_and_panning_progress_touch_y2 = point2.y;
      }
      return;
    }
    default: {
      return;
    }
  }
};
